/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerGCSInspections.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for GCS Inspections
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, April 03, 2019 - 04:09:39 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      04/03/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    GCSINSPECTION_LIST_CONTAINER_LOADED,
    GCSINSPECTION_LIST_CONTAINER_UNLOADED,
    GCSINSPECTION_LIST_TABLE_LOADED,
    GCSINSPECTION_LIST_TABLE_UNLOADED,

    GCSINSPECTION_SELECT_ROW,
    GCSINSPECTION_ADD,
    GCSINSPECTION_EDIT,
    GCSINSPECTION_DELETE,
    GCSINSPECTION_OPEN_WARNING,
    GCSINSPECTION_CLOSE_WARNING,
    GCSINSPECTION_DELETE_DISABLE,

    GCSINSPECTION_EDIT_CONTAINER_LOADED,
    GCSINSPECTION_EDIT_CONTAINER_UNLOADED,
    GCSINSPECTION_EDIT_FORM_LOADED,
    GCSINSPECTION_EDIT_FORM_UNLOADED,
    GCSINSPECTION_EDIT_DATA_LOAD,
    GCSINSPECTION_EDIT_CONTAINER_SUBMIT,
    GCSINSPECTION_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeGCSInspections';

const defaultState = {
    refreshList: false,
    danger: false,
    inspectionid: 0,
    assetid: 0,
    hosedamageid: 0,
    fitdamageid: 0,
    equipmentstatusid: 0,
    pulseid: 0,
    fluidchangeid: 0,
    envexposureid: 0,
    hoseconditionid: 0,
    requestreplacementid: 0,
    fit1photoid: 0,
    hosephotoid: 0,
    fit2photoid: 0,
    notes: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case GCSINSPECTION_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                gcsinspections: action.payload[0] ? action.payload[0].records : null
            }
        case GCSINSPECTION_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case GCSINSPECTION_SELECT_ROW:
            return {
                ...state,
                inspectionid: action.id
            }
        case GCSINSPECTION_ADD:
            return {
                ...state
            }
        case GCSINSPECTION_EDIT:
            return {
                ...state,
                inspectionid: action.id
            }
        case GCSINSPECTION_DELETE:
            return {
                ...state,
                inspectionid: null
            }
        case GCSINSPECTION_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case GCSINSPECTION_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case GCSINSPECTION_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case GCSINSPECTION_EDIT_CONTAINER_LOADED:
        case GCSINSPECTION_EDIT_DATA_LOAD:
            return {
                ...state,
                inspectionid: action.payload[0] ? action.payload[0].INSPECTIONID : 0,
                assetid: action.payload[0] ? action.payload[0].ASSETID : 0,
                hosedamageid: action.payload[0] ? action.payload[0].HOSEDAMAGEID : 0,
                fitdamageid: action.payload[0] ? action.payload[0].FITDAMAGEID : 0,
                equipmentstatusid: action.payload[0] ? action.payload[0].EQUIPMENTSTATUSID : 0,
                pulseid: action.payload[0] ? action.payload[0].PULSEID : 0,
                fluidchangeid: action.payload[0] ? action.payload[0].FLUIDCHANGEID : 0,
                envexposureid: action.payload[0] ? action.payload[0].ENVEXPOSUREID : 0,
                hoseconditionid: action.payload[0] ? action.payload[0].HOSECONDITIONID : 0,
                requestreplacementid: action.payload[0] ? action.payload[0].REQUESTREPLACEMENTID : 0,
                fit1photoid: action.payload[0] ? action.payload[0].FIT1PHOTOID : 0,
                hosephotoid: action.payload[0] ? action.payload[0].HOSEPHOTOID : 0,
                fit2photoid: action.payload[0] ? action.payload[0].FIT2PHOTOID : 0,
                notes: action.payload[0] ? action.payload[0].NOTES : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case GCSINSPECTION_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case GCSINSPECTION_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case GCSINSPECTION_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case GCSINSPECTION_LIST_CONTAINER_UNLOADED:
        case GCSINSPECTION_LIST_TABLE_UNLOADED:
        case GCSINSPECTION_EDIT_CONTAINER_UNLOADED:
        case GCSINSPECTION_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerGCSInspections.js